const CHAVE_POLLING_UNIFICADO = "pollingUnificadoPedidos";
const CHAVES_POLLING_LEGADO = ["autoReload", "integradoIfood", "integrado99Food"];

export function pollingUnificadoPedidosAtivo(): boolean {
  return window.localStorage.getItem(CHAVE_POLLING_UNIFICADO) === "true";
}

export function definirPollingUnificadoPedidos(ativo: boolean): void {
  if (ativo) {
    CHAVES_POLLING_LEGADO.forEach(chave => window.localStorage.removeItem(chave));
  }
  window.localStorage.setItem(CHAVE_POLLING_UNIFICADO, String(ativo));
}
